import axios from "axios";
import customAxios from "../../customHook/customAxios";

const qs = (params) => {
    const parts = Object.entries(params)
        .filter(([, value]) => value !== undefined && value !== null && value !== '')
        .map(([key, value]) => `${key}=${encodeURIComponent(value)}`);
    return parts.length ? `?${parts.join('&')}` : '';
};

/* folders */

export const v3_dms_folders = async (projectId) =>
    customAxios.get(`/v3/dms/folders${qs({ projectId })}`).then((res) => res.data);

export const v3_dms_create_folder = async (model) =>
    customAxios.post('/v3/dms/folder', model).then((res) => res.data);

export const v3_dms_update_folder = async (model) =>
    customAxios.put('/v3/dms/folder', model).then((res) => res.data);

export const v3_dms_delete_folder = async (id) =>
    customAxios.delete(`/v3/dms/folder/${id}`).then((res) => res.data);

/* files */

export const v3_dms_files = async (params) =>
    customAxios.get(`/v3/dms/files${qs(params)}`).then((res) => res.data);

export const v3_dms_create_files = async (model) =>
    customAxios.post('/v3/dms/files', model).then((res) => res.data);

export const v3_dms_update_file = async (model) =>
    customAxios.put('/v3/dms/file', model).then((res) => res.data);

export const v3_dms_delete_file = async (id) =>
    customAxios.delete(`/v3/dms/file/${id}`).then((res) => res.data);

// Preview/download are plain <a>/<img> targets, so they need a URL, not a promise.
export const v3_dms_file_preview_url = (fileId) =>
    `${process.env.REACT_APP_BASE_URL}/v3/dms/file/${fileId}/preview`;

export const v3_dms_file_download_url = (fileId) =>
    `${process.env.REACT_APP_BASE_URL}/v3/dms/file/${fileId}/download`;

/* share links */

export const v3_dms_create_share = async (model) =>
    customAxios.post('/v3/dms/share', model).then((res) => res.data);

export const v3_dms_shares = async (projectId) =>
    customAxios.get(`/v3/dms/shares${qs({ projectId })}`).then((res) => res.data);

export const v3_dms_revoke_share = async (id) =>
    customAxios.delete(`/v3/dms/share/${id}`).then((res) => res.data);

export const v3_dms_share_log = async (id) =>
    customAxios.get(`/v3/dms/share/${id}/log`).then((res) => res.data);

/* public — plain axios so no Authorization header leaks to a recipient's session,
   and so a logged-out visitor is never bounced to /login by the interceptor. */

const publicBase = `${process.env.REACT_APP_BASE_URL}/v3/public/share`;

export const v3_public_share_detail = async (token) =>
    axios.get(`${publicBase}/${token}`).then((res) => res.data);

export const v3_public_share_preview_url = (token, fileId) =>
    `${publicBase}/${token}/file/${fileId}/preview`;

export const v3_public_share_download_url = (token, fileId) =>
    `${publicBase}/${token}/file/${fileId}/download`;
